/*
 * Module containing javascript functionality for the cookie consent control
 */

rs.module("controls/components/cookieconsent", [],

    function () {

        function initialize(controlID, allowJsSelector, denyJsSelector, acceptCookie, denyCookie) {

            var _container = $.js(controlID);

            // Set the cookie and hide the container when clicking allow
            _container.js(allowJsSelector).on("click", function () { _saveAndHide(acceptCookie); });
			_container.js(denyJsSelector, { required:false }).on("click", function () { _saveAndHide(denyCookie); });

            function _saveAndHide(cookie) { 
                document.cookie = cookie;
                _container.fadeOut("slow");
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);